import { render, staticRenderFns } from "./MyTechPreview.vue?vue&type=template&id=ad4c74d8"
import script from "./MyTechPreview.vue?vue&type=script&lang=js"
export * from "./MyTechPreview.vue?vue&type=script&lang=js"
import style0 from "./MyTechPreview.vue?vue&type=style&index=0&id=ad4c74d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports